import { Button, Text, tokens } from '@hotjar/hotsauce';
import { useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '@hotjar/translations';
import { TransferOwnershipModal } from './TransferOwnershipModal';

const SettingsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${tokens.spacer.x1};
`;

export const TransferOwnershipSection = (): JSX.Element => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { t } = useTranslation('account', { keyPrefix: 'transfer-ownership' });

  return (
    <>
      <SettingsSection>
        <Text as="h5" textType="header5">
          {t('section-title')}
        </Text>
        <Text textType="body2">{t('section-subtitle')}</Text>
        <Button
          id="accountTransferShowModal"
          kind="secondary"
          onClick={() => setIsModalVisible((val) => !val)}
          size="m"
        >
          {t('section-button')}
        </Button>
      </SettingsSection>
      <TransferOwnershipModal isVisible={isModalVisible} onClose={() => setIsModalVisible(false)} />
    </>
  );
};
